__turbopack_context__.v({
  "container": "UgWarrantyExtension-module-scss-module__WvXytq__container",
  "dot": "UgWarrantyExtension-module-scss-module__WvXytq__dot",
  "error": "UgWarrantyExtension-module-scss-module__WvXytq__error",
  "iframe": "UgWarrantyExtension-module-scss-module__WvXytq__iframe",
  "loading": "UgWarrantyExtension-module-scss-module__WvXytq__loading",
  "pulse": "UgWarrantyExtension-module-scss-module__WvXytq__pulse",
  "retry": "UgWarrantyExtension-module-scss-module__WvXytq__retry",
});
